import React, { Component } from "react";
import {
  MyGalleryCardFooterWrapper,
  SettingIcon,
  SettingIconArea,
  SettingDropdown,
  DropdownItem,
} from "@/UserPage/Common/MyVideoCardFooter/MyVideoCardFooter.style";
import i18n from '@/i18n';
import { ClickAwayListener } from '@material-ui/core';

export class MyUploadedVideoCardFooter extends Component {
  render() {
    const {
      onSettingClicked,
      onChangeTitle,
      onChangeThumbnail,
      onShare,
      video,
      handleClickAway,
      galleryUpload,
      thumbnailUrl
    } = this.props;
    
    let isGalleryOpen;
    if (video.isGalleryOpen) {
      isGalleryOpen = video.isGalleryOpen
    } else {
      isGalleryOpen = false
    }

    return (
      <MyGalleryCardFooterWrapper>
        <SettingIconArea>
          <ClickAwayListener onClickAway={this.props.id === video._id && this.props.show ? handleClickAway : () => { }}>
            <SettingIcon
              src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/settingicon.svg"
              onClick={onSettingClicked}
              title={i18n.t("myvideocardfooter.icon.title4")}
            />
          </ClickAwayListener>
          <SettingDropdown ref={ref => this.box = ref} show={this.props.id === video._id && this.props.show}>
            <DropdownItem onClick={() => onChangeTitle(video)}>{i18n.t("ChangeTitleInput.dialog.title")}</DropdownItem>
            <DropdownItem onClick={() => onChangeThumbnail(video._id, thumbnailUrl)}>{i18n.t("ChangeTitleInput.dialog.thumbnail")}</DropdownItem>
            <DropdownItem onClick={() => onShare(video)}>{i18n.t("web.myvideo.share")}</DropdownItem>
            <DropdownItem onClick={() => galleryUpload(video)}>{isGalleryOpen ? i18n.t("web.myvideo.gallery.footer.delete") : i18n.t("web.myvideo.gallery.footer.upload")} </DropdownItem>
          </SettingDropdown>
        </SettingIconArea>
      </MyGalleryCardFooterWrapper>
    );
  }
}
